import React, { useState, useContext } from "react";
import { Form, Input, Button, Typography, message, Card } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { axiosForm } from "../../axiosInstances";
import { AuthContext } from "./AuthContext";
import Logo from "../common/Logo";

const { Title } = Typography;

const ChangePasswordForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);

  // Get the username from location.state (passed from LoginForm)
  const username = location.state?.username;

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Step 1: Change password
      await axiosForm.post("/authentication/api/first-change-password/", {
        username,
        new_password: values.new_password,
      });
      // Step 2: Log in automatically with the new password
      const response = await axiosForm.post("/authentication/token/", {
        username: username,
        password: values.new_password,
      });
      login(response.data.access, response.data.refresh); // Save tokens
      message.success("Mot de passe modifié avec succès. Bienvenue !");
      navigate("/dashboard");
    } catch (error) {
      message.error(
        error.response?.data?.detail ||
          "Erreur lors du changement de mot de passe."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        position: "relative"
      }}
    >
      <Card
        style={{
          maxWidth: 400,
          width: "100%",
          padding: 24,
          borderRadius: 12,
          boxShadow: "0 2px 16px #0002",
          zIndex: 1,
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Logo size={300} />
        </div>
        <Title level={3} style={{ textAlign: "center" }}>
          Changer le mot de passe
        </Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Nouveau mot de passe"
            name="new_password"
            rules={[{ required: true, message: "Veuillez saisir un nouveau mot de passe" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmez le nouveau mot de passe"
            name="confirm"
            dependencies={["new_password"]}
            rules={[
              { required: true, message: "Confirmez le nouveau mot de passe" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Les mots de passe ne correspondent pas");
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ marginTop: 8 }}
            >
              Changer le mot de passe
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePasswordForm;
